// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__26hS2","buttons":"PendingPaymentAlert_buttons__21uGI"};